// version2
import React, { useEffect, useState, useRef, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Spinner } from "react-bootstrap";
import { Tooltip } from "@mui/material";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Styles
import "./CodingSupport.css";

// Icons
import generalsurgeryIcon from "../../../common/assets/images/general-surgery-icon.png";

// Redux actions
import {
  fetchCodingSupport,
  updateCodingSupportFilters,
  resetCodingSupportFilters,
  fetchCodingSupportQueues,
  fetchCodingSupportcards,
} from "./Redux/codingSupportSlicer";
import MissingNotes from "./MissingNotes/MissingNotes";
import AwaitingCDQs from "./AwaitingCDQs/AwaitingCDQs";

const CodingSupport = () => {
  const dispatch = useDispatch();
  const containerRef = useRef(null);

  // Redux selectors
  const codingSupportPayload = useSelector(
    (state) => state.codingSupport.codingSupportPayload,
  );

  const [selectedQueue, setSelectedQueue] = useState("Awaiting CDQ");
  const [coderSearchTerm, setCoderSearchTerm] = useState("");


  const { loading: queuesLoading, data: queuesData } = useSelector(
    (state) => state.codingSupport.codingSupportQueues,
  );

  // Initialize data
  // 1️⃣ Initial load → reset + fetch queues
useEffect(() => {
  dispatch(resetCodingSupportFilters());
  dispatch(fetchCodingSupportQueues());
}, [dispatch]);


const queueToPass = useMemo(() => {
  return queuesData?.queues?.find(
    (item) => item?.queue_name === selectedQueue
  );
}, [selectedQueue, queuesData]);


useEffect(() => {
  if (!queueToPass?.queue_id) return;

  const updatedPayload = {
    ...codingSupportPayload,
    queue: [queueToPass.queue_id], 
  };

  console.log("Final Payload:", updatedPayload);

  dispatch(fetchCodingSupport(updatedPayload));
  dispatch(fetchCodingSupportcards(updatedPayload));

}, [queueToPass]);

  const handleQueueSelect = (queueItem) => {
    const payload = {
      separation_date_from: null,
      separation_date_to: null,
      admission_date_from: null,
      admission_date_to: null,
      medical_record_number: [],
      speciality: [],
      queue: [queueItem.queue_id],
      // queue: [],
      priority: [],
      status: [],
      page_number: 1,
      page_size: 10,
      episode_identifier_search: [],
      health_fund_contract: [],
      los: [],
      los_op: null,
      drg_code: [],
      sort_by: [],
      sort_order: [],
      reasons: [],
      is_global_search: false,
    };
    setSelectedQueue(queueItem?.queue_name);
    dispatch(updateCodingSupportFilters(payload));
    setCoderSearchTerm("");
  };

  // Render queue item
  const renderQueueItem = (queueItem) => {
    // Truncate queue name for display
    const MAX_NAME_LENGTH = 22;
    const displayName =
      queueItem.queue_name.length > MAX_NAME_LENGTH
        ? `${queueItem.queue_name.substring(0, MAX_NAME_LENGTH)}...`
        : queueItem.queue_name;
    return (
      <div
        key={queueItem.queue_id}
        className="cs-queue-item"
        style={{
          backgroundColor:
            selectedQueue === queueItem.queue_name ? "#f3f4f6" : undefined,
        }}
        onClick={() => handleQueueSelect(queueItem)}
      >
        <div className="cs-queue-icon">
          <img src={generalsurgeryIcon} alt="" />
        </div>

        <Tooltip title={queueItem?.queue_name} arrow placement="right">
          <div className="cs-queue-name-wrapper">
            <span className="cs-queue-name">{displayName}</span>
          </div>
        </Tooltip>

        <div className="cs-queue-count">({queueItem?.number_of_episodes})</div>
      </div>
    );
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />

      <div className="cs-container">
        {/* --- Left Sidebar (Queues) --- */}
        <div className="cs-left-card">
          <div className="cs-queues-section">
            <p className="cs-queues-header">Queues</p>
            <div className="cs-queues-list-container" ref={containerRef}>
              {queuesLoading ? (
                <div className="cs-queues-loading">
                  {/* Loading queues... */}
                  <Spinner />
                </div>
              ) : (
                (queuesData?.queues || []).map(renderQueueItem)
              )}
            </div>
          </div>
        </div>

        {/* --- Main Content --- */}
        {selectedQueue === "Missing notes" ? (
          <MissingNotes filtersPayload={codingSupportPayload} selectedQueue = {queueToPass} coderSearchTerm={coderSearchTerm} setCoderSearchTerm={setCoderSearchTerm} />
        ) : (
          <AwaitingCDQs filtersPayload={codingSupportPayload} selectedQueue = {queueToPass} coderSearchTerm={coderSearchTerm} setCoderSearchTerm={setCoderSearchTerm}/>
        )}
      </div>
    </>
  );
};

export default CodingSupport;
